import LegalPageLayout from "./LegalPageLayout";

const SECTIONS = [
  {
    heading: "1. Introduction",
    blocks: [
      {
        type: "p",
        text: "MagicBolt Private Limited (\"MagicBolt AI\", \"we\", \"us\", or \"our\") operates the MagicBolt AI platform, which helps digital agencies and businesses automate Google Business Profile, Facebook, Instagram, WordPress and related marketing workflows. This Privacy Policy explains what information we collect, how we use it, and the choices you have.",
      },
      {
        type: "p",
        text: "By using our website or platform, you agree to the collection and use of information in accordance with this policy.",
      },
    ],
  },
  {
    heading: "2. Information We Collect",
    blocks: [
      { type: "p", text: "We collect the following categories of information:" },
      {
        type: "ul",
        items: [
          "Account information - name, email address, phone number, company/agency name, and billing details you provide when signing up.",
          "Client & channel data - content, credentials and metadata you connect from Google Business Profile, Facebook, Instagram, WordPress and other integrated channels, used solely to deliver the automation service.",
          "Usage data - pages visited, features used, device/browser type, IP address and log data collected automatically via cookies and analytics tools.",
          "Communications - messages you send us via contact forms, email or WhatsApp support.",
        ],
      },
    ],
  },
  {
    heading: "3. How We Use Your Information",
    blocks: [
      {
        type: "ul",
        items: [
          "To provide, operate and maintain the MagicBolt AI platform and its automations.",
          "To process subscriptions, billing and white-label/reseller accounts.",
          "To respond to support requests and communicate service updates.",
          "To improve our product, troubleshoot issues and secure our systems.",
          "To send product updates or marketing communications, which you may opt out of at any time.",
        ],
      },
    ],
  },
  {
    heading: "4. Cookies & Tracking",
    blocks: [
      {
        type: "p",
        text: "With your consent, we use Google Analytics and Meta Pixel cookies on our website to understand how visitors use our site and to measure our advertising. These load only after you accept them in the cookie banner. You can withdraw your consent at any time from \"Cookie settings\" in the website footer, which removes these cookies. A single cookie that records your choice is always stored so we do not ask on every visit.",
      },
    ],
  },
  {
    heading: "5. Data Sharing & Third-Party Services",
    blocks: [
      {
        type: "p",
        text: "We do not sell your personal information. We may share data with:",
      },
      {
        type: "ul",
        items: [
          "Third-party platforms you connect (e.g. Google, Meta/Facebook, Instagram, WordPress) strictly to perform the automations you configure.",
          "Service providers who support hosting, payments, analytics and customer support, under confidentiality obligations.",
          "Authorities, where required by law or to protect our legal rights.",
        ],
      },
    ],
  },
  {
    heading: "6. Data Security",
    blocks: [
      {
        type: "p",
        text: "We use industry-standard technical and organizational measures, including encryption in transit, access controls and regular reviews, to protect your data. No method of transmission or storage is 100% secure, and we cannot guarantee absolute security.",
      },
    ],
  },
  {
    heading: "7. Data Retention",
    blocks: [
      {
        type: "p",
        text: "We retain account and channel data for as long as your account is active or as needed to provide the service. You may request deletion of your data, subject to legal and legitimate business retention requirements, by contacting us.",
      },
    ],
  },
  {
    heading: "8. Your Rights",
    blocks: [
      {
        type: "p",
        text: "Depending on your location, you may have the right to access, correct, export or delete your personal information, or to withdraw consent for marketing communications. To exercise these rights, contact us using the details below.",
      },
    ],
  },
  {
    heading: "9. Children's Privacy",
    blocks: [
      {
        type: "p",
        text: "MagicBolt AI is intended for business use and is not directed at individuals under 18. We do not knowingly collect personal information from children.",
      },
    ],
  },
  {
    heading: "10. Changes to This Policy",
    blocks: [
      {
        type: "p",
        text: "We may update this Privacy Policy from time to time. Material changes will be reflected by an updated \"Last updated\" date on this page. Continued use of MagicBolt AI after changes constitutes acceptance of the revised policy.",
      },
    ],
  },
  {
    heading: "11. Contact Us",
    blocks: [
      {
        type: "p",
        text: "For any questions about this Privacy Policy or your data, contact us at support@magicbolt.ai or write to MagicBolt Private Limited, Zone-I, Maharana Pratap Nagar, Bhopal, Madhya Pradesh 462012, India.",
      },
    ],
  },
];

export default function PrivacyPolicyPage() {
  return (
    <LegalPageLayout
      testId="privacy-policy-page"
      title="Privacy Policy - MagicBolt AI"
      description="Learn how MagicBolt Private Limited collects, uses and protects your data across the MagicBolt AI platform."
      path="/privacy-policy"
      eyebrow="Your data, protected"
      heading="Privacy Policy"
      updated="October 12, 2026"
      sections={SECTIONS}
    />
  );
}
